/**
 * Constants for all content sort types
 * @module services/content/sort-types
 */
export const SORT_TYPE_CONTENT_ID = 'content-id'
export const SORT_TYPE_CONTENT_PUBLISHED_AT_DATE = 'published-at-date'
export const SORT_TYPE_POPULAR = 'popular'
export const SORT_TYPE_RECOMMENDED = 'recommended'
export const SORT_TYPE_SEASON_EPISODE = 'season-episode'
